import { i18nMark } from 'lingui-react';

const messages = {
  cancelButton: i18nMark('Cancel'),
  loadingRecipientsError: i18nMark('Sorry, we had a connection issue while loading recipients. Please try again.'),
  maxRecipientsError: i18nMark('You reached the max of 15 recipients. Remove some recipients to enable the Post button.'),
  newNote: i18nMark('New Note'),
  noRecipientsError: i18nMark('We didn\'t find any possible recipients. Please contact our support services team.'),
  postButton: i18nMark('Post'),
  title: i18nMark('New Note'),
  to: i18nMark('To:'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/NotesWidget/NoteCreator/messages.js